import { Link, NavLink } from 'react-router-dom';
import { useState } from 'react';
import { useCart } from '../store/cart';
import CartPopover from './CartPopover';

const nav = [
  { to: '/', label: 'Inicio' },
  { to: '/tienda', label: 'Tienda' },
  { to: '/contacto', label: 'Contacto' },
];

export default function Header() {
  const totalItems = useCart((s) => s.totalItems());
  const toggleCart = useCart((s) => s.toggle);
  const cartOpen = useCart((s) => s.isOpen);
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-ink-950/60 border-b border-ink-700/60">
      <div className="container-app h-20 lg:h-24 flex items-center justify-between gap-6">
        <Link to="/" className="flex items-center gap-0 group shrink-0 translate-y-1" aria-label="VapSilver - Inicio">
          <span aria-hidden className="inline-flex h-[3.25rem] w-[3.25rem] items-center justify-center -mr-2 -mt-1">
            <img src="/Vapsilver_logo.png" alt="" className="h-full w-full object-cover scale-[3.25] origin-center" loading="eager" />
          </span>
          <span className="relative top-1 text-[2rem] sm:text-[2.1rem] leading-none font-semibold tracking-tighter">
            ap<span className="text-vapor-400">Silver</span>
          </span>
        </Link>

        <nav aria-label="Navegacion principal" className="hidden lg:flex items-stretch h-full">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === '/' || n.to === '/tienda'}
              className={({ isActive }) =>
                `group relative flex items-center px-4 text-[18px] font-medium transition-colors ${
                  isActive ? 'text-bone-50' : 'text-bone-300 hover:text-bone-50'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <span className="relative z-10">{n.label}</span>
                  <span className="pointer-events-none absolute inset-x-3 bottom-0 h-6 bg-gradient-to-t from-white/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                  <span
                    className={`pointer-events-none absolute inset-x-3 bottom-0 h-px bg-white transition-opacity duration-200 ${
                      isActive ? 'opacity-90' : 'opacity-0 group-hover:opacity-70'
                    }`}
                  />
                </>
              )}
            </NavLink>
          ))}
        </nav>

        {/* El desplegable del carrito mide 320 px y se centra bajo el botón, así que
            necesita 172 px libres hasta el borde de la ventana. Entre 768 y 1535 px el
            botón queda demasiado pegado al borde: se separa para que quepa centrado.
            A partir de 1536 el contenedor ya deja sitio de sobra y el margen sobra. */}
        <div className="flex items-center gap-2 md:mr-32 2xl:mr-0">
          {/* Contenedor de referencia: de aquí cuelga el desplegable del carrito. */}
          <div className="relative">
            <button
              onClick={toggleCart}
              data-cart-toggle
              className="relative btn-ghost !px-3.5 !py-2.5 !text-[15px]"
              aria-label={`Carrito, ${totalItems} artículos`}
              aria-expanded={cartOpen}
              aria-controls="cart-popover"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden>
                <path d="M3 5h2l2.4 12.4a2 2 0 0 0 2 1.6h7.6a2 2 0 0 0 2-1.6L21 8H6" />
                <circle cx="9" cy="21" r="1" />
                <circle cx="18" cy="21" r="1" />
              </svg>
              {totalItems > 0 && (
                <span className="absolute -top-1 -right-1 bg-vapor-400 text-ink-950 text-[10px] font-bold rounded-full h-5 min-w-[20px] px-1 inline-flex items-center justify-center">
                  {totalItems}
                </span>
              )}
            </button>
            <CartPopover />
          </div>

          <button
            className="lg:hidden btn-ghost !px-3.5 !py-2.5"
            aria-label="Menu"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
              {open ? <path d="M6 6l12 12M6 18L18 6" /> : <path d="M4 7h16M4 12h16M4 17h16" />}
            </svg>
          </button>
        </div>
      </div>

      {open && (
        <nav className="lg:hidden border-t border-ink-700 bg-ink-900/90 backdrop-blur-md" aria-label="Navegacion movil">
          <div className="container-app py-3 grid gap-1">
            {nav.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === '/' || n.to === '/tienda'}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-lg text-sm ${isActive ? 'bg-ink-800 text-bone-50' : 'text-bone-300'}`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}
